// Components
import { Box, LinearProgress, CircularProgress, } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import themeApp from "../../providers/themeProvider";

const themeConfig = require("../../config/index").default;
const logo = require(`../../assets/images/${themeConfig.companyLoaddingLogo}`).default;

/**
 * Render a view of loading
 * @returns {component} Show loader of the app
 */
export function LoaderApp() {
  return (
    <ThemeProvider theme={themeApp}  >
      <Box
        position="fixed"
        width="100%"
        height="100vh"
        display="flex"
        alignItems="center"
        flexDirection="column"
        justifyContent="center"
        zIndex={100000}
      >
        {/* Capa de fondo */}
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          style={{
            backgroundColor: "#000000",
            opacity: 0.6,
            zIndex: 0,
          }}
        />

        {/* Contenido */}
        <CircularProgress
          size="7rem"
          thickness={1}
          style={{
            color: "#fff",
            zIndex: 1,
          }}
        />
        <img
          src={logo}
          height={95}
          style={{
            objectFit: "contain",
            position: "absolute",
            zIndex: 1, // Asegura que esté encima del fondo
          }}
          alt="Logo"
        />
      </Box>
    </ThemeProvider>
  );
}
